import { render, staticRenderFns } from "./ExpiredOffers.vue?vue&type=template&id=28ae3e2b&"
import script from "./ExpiredOffers.vue?vue&type=script&lang=js&"
export * from "./ExpiredOffers.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports